import TSCockpitResult from './TSCockpitResult';

export default class TSCockpitResultDTO {

    private _cockpitResult: Array<TSCockpitResult> = [];
    private _name: string;

    constructor() {
        this._name = 'Keine Resultate';
    }

    public get cockpitResult(): Array<TSCockpitResult> {
        return this._cockpitResult;
    }

    public set cockpitResult(value: Array<TSCockpitResult>) {
        this._cockpitResult = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public parseCockpitResultDTOs(data: any): TSCockpitResult[] {
        let results: TSCockpitResult[] = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                if (data[i]) {
                    results[i] = new TSCockpitResult().deserialize(data[i]);
                }
            }
        } else {
            results[0] = new TSCockpitResult().deserialize(data);
        }
        return results;
    }

    deserialize(restObject: any): TSCockpitResultDTO {

        this.cockpitResult = this.parseCockpitResultDTOs(restObject.cockpitResults);
        this.name = restObject.name;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSCockpitResultDTO.ts